import React, { useMemo } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, ShieldX } from 'lucide-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

export function AccessDeniedPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { isAuthenticated } = useAuth();

  const platform = useMemo(() => String(searchParams.get('platform') || '').trim(), [searchParams]);
  const message = useMemo(() => String(searchParams.get('message') || '').trim(), [searchParams]);

  const title = platform ? `You do not have access to ${platform}` : 'Access denied';
  const body =
    message ||
    (platform
      ? 'Your HK Identity account is not permitted to open this platform. If you believe this is a mistake, contact an administrator.'
      : 'Your HK Identity account is not permitted to open this resource. If you believe this is a mistake, contact an administrator.');

  return (
    <div className="login-screen">
      <motion.div
        initial={{ opacity: 0, scale: 0.97 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.28 }}
        className="login-card"
      >
        <div className="login-logo-wrap" aria-hidden="true">
          <div className="login-logo-circle" style={{ display: 'grid', placeItems: 'center' }}>
            <ShieldX size={46} />
          </div>
        </div>

        <div className="login-title-row login-title-center">
          <h2>{title}</h2>
          <p className="hint-text">HK Identity security policy blocked this request.</p>
        </div>

        <div className="status-banner danger">
          <strong>Access denied</strong>
          <span>{body}</span>
        </div>

        <div className="inline-row" style={{ marginTop: 18, width: '100%' }}>
          <motion.button
            type="button"
            className="primary-button"
            whileTap={{ scale: 0.98 }}
            onClick={() => navigate(isAuthenticated ? '/platforms' : '/login', { replace: true })}
            style={{ width: '100%', justifyContent: 'center' }}
          >
            <ArrowLeft size={16} />
            Back to HK Identity
          </motion.button>
        </div>
      </motion.div>
    </div>
  );
}

